<template>
	<main class="h-100 d-flex flex-column user-header">
		<BNavbar
			v-if="user.id"
			toggleable="xl"
			type="light"
			class="mb-2"
			style="border: none;">
			<BContainer>
				<BNavbarBrand
					class="d-flex align-items-center gap"
					href="/">
					<svg
						width="24"
						viewBox="0 0 190 164" fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<g filter="url(#filter0_d)">
							<path d="M25.5881 87.6945H8.58C7.17712 87.6945 6.42277 86.0466 7.33956 84.9847L77.7901 3.38597C78.5499 2.5059 79.655 2 80.8177 2H109.424C110.559 2 111.64 2.48167 112.398 3.3251L183.487 82.3633C183.817 82.7305 184 83.2069 184 83.7008V86.8847C184 87.9893 183.105 88.8847 182 88.8847H173.26V147.156C173.26 150.469 170.574 153.156 167.26 153.156H36.011C32.7244 153.156 30.06 150.491 30.06 147.205C30.06 143.918 32.7243 141.254 36.011 141.254H56.3133V103.167V102.645C56.3133 97.6749 60.3428 93.6455 65.3133 93.6455H91.4667C96.4372 93.6455 100.467 97.6749 100.467 102.645V103.167V141.254H126.72V84.1239L77.7933 30.5648L27.076 87.0309C26.6967 87.4533 26.1557 87.6945 25.5881 87.6945Z" fill="url(#paint0_linear)" />
						</g>
						<defs>
							<filter id="filter0_d" x="0.937988"
								y="0" width="189.062"
								height="163.156" filterUnits="userSpaceOnUse"
								color-interpolation-filters="sRGB">
								<feFlood flood-opacity="0" result="BackgroundImageFix" />
								<feColorMatrix in="SourceAlpha" type="matrix"
									values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
								<feOffset dy="4" />
								<feGaussianBlur stdDeviation="3" />
								<feComposite in2="hardAlpha" operator="out" />
								<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
								<feBlend mode="normal" in2="BackgroundImageFix"
									result="effect1_dropShadow" />
								<feBlend mode="normal" in="SourceGraphic"
									in2="effect1_dropShadow" result="shape" />
							</filter>
							<linearGradient id="paint0_linear" x1="94.5"
								y1="2" x2="94.5"
								y2="153.156" gradientUnits="userSpaceOnUse">
								<stop stop-color="#F99723" />
								<stop offset="0.9999" stop-color="#FF4E50" />
								<stop offset="1" stop-color="#FF4E50" />
							</linearGradient>
						</defs>
					</svg>
					MyAbdom
				</BNavbarBrand>
				<BNavbarToggle target="navbarCollapse"></BNavbarToggle>
				<BCollapse
					id="navbarCollapse"
					:model-value="navbarVisible"
					is-nav
					@update:model-value="navbarVisible = $event">
					<hr class="d-md-none mt-2 mb-0 border-gray-300">
					<BNavbarNav class="mr-auto">
						<BNavItem to="/" exact
							active-class="active">
							Dashboard
						</BNavItem>
						<BNavItem v-if="isClient" to="/bookings"
							exact active-class="active">
							My Bookings
						</BNavItem>
						<template v-if="user.is_cleaner">
							<BNavItemDropdown text="Fees">
								<BDropdownItem to="/fees">
									Absolute Domestics Fees
								</BDropdownItem>
								<BDropdownItem v-if="user.accepts_invoice_jobs" to="/clean-homes-fees">
									Clean Homes Fees
								</BDropdownItem>
							</BNavItemDropdown>
						</template>
						<BNavItem v-if="isCleaner" to="/payments">
							Payments
						</BNavItem>
					</BNavbarNav>
					<BNavbarNav class="ml-auto">
						<BNavItemDropdown text="Account">
							<BDropdownItem to="/account">
								Settings
							</BDropdownItem>
							<BDropdownItem v-if="user.is_cleaner" to="/payment-summaries">
								Payment Summaries
							</BDropdownItem>
						</BNavItemDropdown>
						<li v-if="impersonating" class="nav-item">
							<form method="POST" action="/stop-impersonating">
								<input type="hidden" name="_token"
									:value="csrfToken">
								<button type="submit" class="nav-link btn btn-link text-danger font-weight-bold">
									Stop impersonating
								</button>
							</form>
						</li>
						<BNavItem href="/logout">
							Logout
						</BNavItem>
					</BNavbarNav>
				</BCollapse>
			</BContainer>
		</BNavbar>
		<div class="content pt-3 flex-fill h-100">
			<transition
				name="fade"
				mode="out-in">
				<router-view :key="$route.fullPath" />
			</transition>
		</div>
		<session-expired-modal></session-expired-modal>
	</main>
</template>

<script>
	import SessionExpiredModal from '@js/components/helpers/SessionExpiredModal.vue';

	export default {
		name: 'App',
		components: {SessionExpiredModal},
		props: {
			// true while a staff member is impersonating this user
			impersonating: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				navbarVisible: false,
				csrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
			};
		},
		computed: {
			isLoggedIn() {
				return this.$store.getters['auth/user'].id ? this.$store.getters['auth/user'] : false;
			},
			user() {
				return this.$store.getters['auth/user'];
			}
		},
		watch: {
			'$route.path'() {
				this.navbarVisible = false;
			},
		},
	}
</script>
